export enum ParameterType {
    serializable,
    callback,
    remoteObject,
    transferable
}
